<app-header (selection)="onHeaderSelection($event)"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>